const SystemType = {
    Default: 'default',
    ERP: 'erp',
    Custom: 'custom',
    POS: 'pos'
};

export {SystemType};

